import React from 'react';
import Radium from 'radium'
import ButtonWithIcon from "../Utils/ButtonWithIcon";
import small_button_bg from "../../images/small_button_bg.svg";
import accept_white from "../../images/icons/accept-white.svg";
import accept_gray from "../../images/icons/accept-gray.svg";
const ModeratorSetStatusCard= (props) => {
    const cardStyle ={
        width: '100%',
        height: '50px',
        background: 'white',
        paddingBottom: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
    const textStyle = {
        paddingLeft:'20px',
        fontSize: '1.2em',
        textAlign: 'left',
        fontFamily: 'Mont',
        textTransform: 'uppercase'
    }
    const buttonStyle = {
        paddingRight: '20px',
        width: '30px',
        height: '30px'
    }
    const imageStyle = {
        paddingTop: '7px',
        paddingRight: '5px'
    }
    let button = <ButtonWithIcon onClick={props.OnSetStatus}
                                    background={small_button_bg}
                                    icon={accept_white}
                                    bgColor="#5490F2"
                                    bgColorHover='#87B4FF'
                                    bgColorActive='#0061FF'
                                    size={30}
    />
    let check = <img src={accept_gray} style={imageStyle} alt=""/>
    return <div style={cardStyle}>
        <div style={textStyle}>
            {props.name}
        </div><div style={buttonStyle}>
            {props.index >= props.currentTeamState ? button : check }

        </div>

    </div>

}


export default Radium(ModeratorSetStatusCard);